import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { ConditionPanelPopover } from '@/components/conditions/conditionPanelPopover';
import { useConditionPanel } from '@/components/conditions/useConditionPanel';
import { findValueCondition } from '@/types/advanceFilter';
import { TagsCondition } from './tagsCondition';
import type { TagsFilterProps } from './tagsFilter';
type TagsConditionSelectorProps = Omit<TagsFilterProps, 'allowChangingFilterMode' | 'onDoneClick' | 'panelTitle'>;
export const TagsConditionSelector = (props: TagsConditionSelectorProps) => {
  const panel = useConditionPanel(props.panelHost, props.onPanelClose);
  const condition = findValueCondition(props.conditions, props.property.name);
  const selectedTags = condition?.value ?? [];
  return <>
      {!panel.isHosted && <Button ref={panel.triggerRef} onClick={panel.toggle} disableFocusRipple size='small' className='px-0 py-[5px]'>
          <Stack direction={'row-reverse'} className='pl-[12px] pr-[8px]' sx={{
        gap: '8px'
      }}>
            <i className='material-symbols-arrow-drop-down-rounded text-xl align-middle min-w-[22px] min-h-[22px] w-[22px] h-[22px]' />
            {selectedTags.length === 0 && <Typography variant='button' className='text-left font-medium' sx={{
          color: 'var(--mui-palette-text-disabled)'
        }}>
                Select
              </Typography>}
            {selectedTags.length > 0 && <Typography variant='button' className='text-left font-medium' sx={{
          color: 'currentcolor'
        }}>
                {selectedTags.join(', ')}
              </Typography>}
          </Stack>
        </Button>}
      <TagsConditionPanelPopover {...props} anchorEl={panel.anchorEl} popoverOpen={panel.isOpen} selectedTags={selectedTags} onChange={props.onChange} onClose={panel.close} />
    </>;
};
interface TagsConditionPanelPopoverProps extends TagsConditionSelectorProps {
  anchorEl: HTMLElement | null;
  popoverOpen: boolean;
  selectedTags: string[];
  onClose: () => void;
}
const TagsConditionPanelPopover = props => {
  const $ = _c(15);
  let t0;
  if ($[0] !== props) {
    t0 = () => props.onClose();
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.conditions) {
    t1 = [...props.conditions];
    $[2] = props.conditions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props) {
    t2 = () => props.onClose();
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t3 = <Stack className="w-[308px]"><TagsCondition {...props} conditions={t1} onChange={props.onChange} onDoneClick={t2} /></Stack>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props.anchorEl || $[11] !== props.popoverOpen || $[12] !== t0 || $[13] !== t3) {
    t4 = <ConditionPanelPopover open={props.popoverOpen} anchorEl={props.anchorEl} onClose={t0}>{t3}</ConditionPanelPopover>;
    $[10] = props.anchorEl;
    $[11] = props.popoverOpen;
    $[12] = t0;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};